import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/announcements'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { BooleanColumn, BsrsGrid, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import context from '@/context'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import Resx from '@/components/Resx'
import { useLocalization } from '@/hooks/localization'
import { commandCell, htmlCell } from './gridButtons'
import { Button } from '@/components/button'
import { dialogTypes } from '@/dialogs'
import { useRfc13Announcements } from '@/hooks/useFeatureFlags'
import moment from 'moment'

const NEW_ANNOUNCEMENT = {
  id: 0,
  validFrom: moment().toDate(),
  validTo: moment().toDate(),
  isActive: false,
  text: '',
  latinText: '',
  isForInternalApp: false,
  isForExternalApp: false,
  isOnlyForSelectedInstitutions: false
}

const Announcements = ({ announcements, openDialog, save, delete: deleteAnnouncement, history }) => {
  const { localize } = useLocalization()
  const isRfc13AnnouncementsEnabled = useRfc13Announcements()

  const openCreateAnnouncementDialog = () => {
    openDialog({
      dialogType: dialogTypes.addNewAnnouncement,
      onAction: (item) => save(item).then(id => {
        openAnnouncementDetail(id)
      }),
      announcement: { ...NEW_ANNOUNCEMENT },
      localize
    })
  }

  const openAnnouncementDetail = (announcementId) => {
    history.push(`/announcements/${announcementId}`)
  }

  const { entityIdBeingDeleted, gridKey } = announcements

  return (
    <Main>
      <MainTop>
        <MainTopTitle><Resx name='Announcements.AnnouncementSettings' /></MainTopTitle>
        <MainTopLeft>
          <Button
            className={'btn-sm'}
            title={localize('Announcements.CreateNewAnnouncement')}
            color='primary'
            icon='plus'
            onClick={() => openCreateAnnouncementDialog()}>{localize('Announcements.AddAnnouncement')}</Button>
        </MainTopLeft>
      </MainTop>
      <MainBody>
        <BsrsGrid
          persistenceId={'announcements-settings'}
          dataSource={context.api.announcementService.getTableData}
          lastReloadedAt={gridKey}
          filterable>
          <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
          <Column field='validTo' title={localize('Common.ValidTo')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
          {BooleanColumn({ field: 'isActive', title: localize('Common.Active'), editable: false, width: '120px' })}
          {BooleanColumn({ field: 'isForInternalApp', title: localize('Enums.ApplicationTypes_0'), editable: false, width: '130px' })}
          {BooleanColumn({ field: 'isForExternalApp', title: localize('Enums.ApplicationTypes_1'), editable: false, width: '130px' })}
          {isRfc13AnnouncementsEnabled && BooleanColumn({ field: 'isOnlyForSelectedInstitutions', title: localize('Announcements.OnlySelected'), editable: false, width: '180px' })}
          <Column field='text' title={localize('Common.Text')} cell={htmlCell()} />
          <Column field='latinText' title={localize('Common.LatinText')} cell={htmlCell()} />
          <Column cell={commandCell({
            localize,
            entityIdBeingDeleted,
            deleteAnnouncement: (id) => deleteAnnouncement(id),
            editAnnouncement: item => openAnnouncementDetail(item.id)
          })} width='50px' filterable={false} />
        </BsrsGrid>
      </MainBody>
    </Main>
  )
}

const mapStateToProps = (state, ownProps) => ({
  announcements: state.announcements,
  ...ownProps
})

const mapDispatchToProps = {
  delete: actionCreators.delete,
  save: actionCreators.save,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(Announcements)



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/announcements/announcements.js